import { IShortItem, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const employeesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_medicalRecordsReporter: builder.query<ITableRes<IShortItem>, void>({
      query: () => {
        return {
          url: `/employees/select/?role=nurse&role=principal&role=vice_principal`,
        }
      },
      providesTags: ['employees'],
      transformResponse: (response: ITableRes<IShortItem>): any => {
          const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
    }),
  }),
})

export const {
  useGET_medicalRecordsReporterQuery,
} = employeesAPI
